import { useState, useEffect } from "react";
import { TextField, Button, Typography, Stack } from "@mui/material";

/**
 * A component that displays a first_name and last_name values and allows editing
 * @param {object} props
 * @param {string} props.initialValue - The starting value to display
 * @param {function(string): Promise<void>} props.onSave - Asynchronous function to call with the new value when saving
 */
const EditableNameField = ({ initialFirstName, initialLastName, onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [firstName, setFirstName] = useState(initialFirstName);
  const [lastName, setLastName] = useState(initialLastName);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setFirstName(initialFirstName);
    setLastName(initialLastName);
  }, [initialFirstName, initialLastName]);

  const handleSave = async () => {
    setLoading(true);
    try {
      await onSave({ first_name: firstName, last_name: lastName });
      setIsEditing(false);
    } catch (error) {
      setError("Falló el guardado de nombre");
      console.error(`Falló el guardado del nombre: ${error}`);
    } finally {
      setLoading(false);
    }
  };

  if (isEditing) {
    return (
      <Stack direction="row" spacing={1} alignItems="center">
        <TextField
          label="Nombre"
          size="small"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          disabled={loading}
        />
        <TextField
          label="Apellido"
          size="small"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          disabled={loading}
          error={!!error}
          helperText={error}
        />
        <Button
          size="small"
          variant="contained"
          onClick={handleSave}
          disabled={loading}
          sx={{
            marginTop: "30px !important",
            borderRadius: "0px !important",
            fontWeight: "bolder !important",
            fontSize: "1rem !important"
          }}
        >
          {loading ? "..." : "Guardar"}
        </Button>
        <Button
          size="small"
          variant="text"
          onClick={() => setIsEditing(false)}
          disabled={loading}
          sx={{ marginTop: "30px !important", fontSize: "1rem !important" }}
        >
          Cancelar
        </Button>
      </Stack>
    );
  }

  return (
    <>
      <Typography variant="body1">{`${initialFirstName} ${initialLastName}`}</Typography>
      <Button
        size="small"
        onClick={() => setIsEditing(true)}
        sx={{
          borderRadius: "0px !important",
          fontWeight: "bolder !important",
          fontSize: "1rem !important"
        }}
      >
        editar
      </Button>
    </>
  );
};

export default EditableNameField;
